import { render, staticRenderFns } from "./shipmentWaybill.vue?vue&type=template&id=12d87f33&scoped=true&"
import script from "./shipmentWaybill.vue?vue&type=script&lang=js&"
export * from "./shipmentWaybill.vue?vue&type=script&lang=js&"
import style0 from "./shipmentWaybill.vue?vue&type=style&index=0&id=12d87f33&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d87f33",
  null
  
)

export default component.exports